import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { TDataToken, TQueries } from "./type";

//get single team details of a cohort of an org
export const getOrgCohortTeamDetails = (
  data: TDataToken,
  payload: TQueries
) => {
  return $api
    .post(
      `/admin/orgs/teams`,
      { ...payload },
      {
        token: data.accessToken,
      }
    )
    .then((response) => {
      return response?.payload?.data;
    });
};
export const useOrgCohortTeamDetailsSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["orgCohortTeamDetails", queries],
    queryFn: () => getOrgCohortTeamDetails(data, queries) as any,
    ...(config as UseQueryOptions<unknown>),
  });
};

//get all users of a team of a cohort of an org
export const getOrgCohortTeamUserDetails = (
  data: TDataToken,
  payload: TQueries
) => {
  return $api
    .get( `admin/groups/team-users`, { token: data.accessToken, params: { ...payload } })
    .then((response) => {
      return response;
    });
};

export const useOrgCohortTeamUserDetailsSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["orgCohortTeamUserDetails", queries],
    queryFn: () => getOrgCohortTeamUserDetails(data, queries) as any,
    ...(config as UseQueryOptions<unknown>),
  });
};